import { render, staticRenderFns } from "./OrganizationPicker.vue?vue&type=template&id=106b3e87&scoped=true"
import script from "./OrganizationPicker.vue?vue&type=script&lang=js"
export * from "./OrganizationPicker.vue?vue&type=script&lang=js"
import style0 from "./OrganizationPicker.vue?vue&type=style&index=0&id=106b3e87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b3e87",
  null
  
)

export default component.exports